/**
 * @Author: v_jppjpeng
 * @Date: 2024-08-16 10:14:58
 * @Explain: 上报集成
 */
import aegisMonitor from '@/utils/aegisMonitor';
import { smlMonitor } from '@/utils/smlMonitor';
import type { ReportEventPrams } from './typing';
// 字典
/** 活动管理 */
import activityManage from './const/activityManage';
/** 公共类 */
import common from './const/common';
/** 联系人上传 */
import contactFromCsv from './const/contactFromCsv';
/** 模板管理 */
import mailTemplate from './const/mailTemplate';
/** 分层管理 */
import segmentManage from './const/segmentManage';
/** 设置管理 */
import settingManage from './const/settingManage';
/** 表单 */
import type { EventTypeEnum } from '../aegisMonitor/typing';
import signUpForm from './const/signUpForm';
/** 埋点事件 */
export const eventNameEnum = {
  ...activityManage,
  ...common,
  ...contactFromCsv,
  ...mailTemplate,
  ...segmentManage,
  ...settingManage,
  ...signUpForm,
};
/** 埋点上报 */
class BurialPoint {
  /**
   * aegis - 上报
   **/
  public aegisReportEvent(params: ReportEventPrams, aegisExts?: any) {
    const { moduleName, eventName, eventType, msg, exts } = params;

    let ext1: any = {};
    // 当配置了这几个参数，则默认加入扩展字段
    if (moduleName && eventType) {
      ext1 = {
        moduleName,
        eventType,
      };
    }

    if (msg) {
      ext1.msg = msg;
    }

    if (exts) {
      ext1 = {
        ...ext1,
        ...exts,
      };
    }
    /**
   * @params
   *  name: string;
      ext1?: any;
      ext2?: any;
      ext3?: any;
    */
    aegisMonitor.reportEvent({ name: eventName, ext1, ...aegisExts, msg });
  }
  public reportEvent(params: ReportEventPrams, aegisExts?: any) {
    this.aegisReportEvent(params, aegisExts);
    // 接口 - 上报
    smlMonitor.reportEvent(params);
  }

  /** aegis 上报
   * 示例：
   * msg: '用户注册成功'
   * ext1: '新用户'
   * ext2: '2025-12-23'
   * ext3：xxxx
   */
  public infoAll(params: {
    msg: string;
    ext1?: string;
    ext2?: string;
    ext3?: string;
    moduleName: string;
    eventName: string;
    eventType: EventTypeEnum;
  }) {
    const { moduleName, eventName, eventType, ...data } = params;
    aegisMonitor?.infoAll?.(data);
    // 接口 - 上报
    smlMonitor.reportEvent({
      moduleName,
      eventName,
      eventType,
      msg: data.msg,
    });
  }
}

export default new BurialPoint();
